<template>
  <div class="clipText">
    <el-tag
      ref="tag"
      :type="type"
      :style="'min-width: ' + tabWidth"
    >
      <slot></slot>
    </el-tag>
    <el-button
      class="clipText-btn"
      type="text"
      @click="copyText"
    >
      <i class="el-icon-copy-document"></i>
    </el-button>
  </div>
</template>

<script>
import { copyText } from '@/utils/copy-text';
export default {
  name: 'ClipText',
  props: {
    tabWidth: {
      type: String,
      default: '100px',
    },
    type: {
      type: String,
      default: 'info',
    },
  },
  methods: {
    copyText() {
      const textToCopy = this.$el.innerText.trim(); // Get text and remove potential extra whitespace
      copyText(textToCopy);
    },
  },
};
</script>

<style lang="scss" scoped>
.clipText {
  display: flex;
  align-items: center;
  font-weight: bold;

  .el-icon-copy-document {
    font-size: 14px;
  }

  &-btn {
    margin-left: 10px;
    color: black !important;
  }
}
</style>